<template>
  <!-- 商品详情顶部导航  和  分层标签 -->
  <div>
    <div class="lists" style="background-color:#006865;">
      <div class="w clearfix">
        <div class="hoverDiv">
          <h3 class="icon" style="height: 34px;" ><i></i>全部商品分类</h3>

        <div class="caidan" style="text-align: left" >
          <div class="menu-con">
            <div class="menu-item" v-for="(item,index) in categoryMenu" :key="index">
              <i class="icon-item" :class="sstt[index]"></i>
              {{item.cateName}}
              <div class="hoverBox">
                <div class="over">
                  <dl v-for="(subItem) in item.children" :key="subItem.id">
                    <router-link :to="{name:'category',query:{classifyData:JSON.stringify(subItem)}}">
                      <dt >{{subItem.cateName}}  </dt>
                    </router-link>
                    <dd style="padding-right: 40px;box-sizing: border-box;">
                      <router-link v-for="(threeItem) in subItem.children" :key="threeItem.id" :to="{name:'category',query:{classifyData:JSON.stringify(threeItem)}}">
                        {{threeItem.cateName}}
                      </router-link>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div>
          <ul style="cursor: pointer;">
            <li @click="goByIndex()">首页</li>
            <li @click="goByPt()">精品推荐</li>
            <li @click="goByqg()">热门榜单</li>
            <li @click="goByjz()">首发新品</li>
            <li @click="goByms()">促销单品</li>
            <li @click="goSiteConfig(1)">关于我们</li>
            <li @click="goSiteConfig(3)">合作咨询</li>
            <li @click="goSiteConfig(4)">解决方案</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import componentMap from './componentMap'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import { mapMutations } from 'vuex'

export default {
  name: 'lateralNavigation',
  mixins: [listSearchMixin],
  mounted() {
    this.canvasGet()
  },
  data () {
    return {
      categoryMenu: null,
      showMenu: false,
      search_text: null,
      // componentMap: componentMap,
      sstt: [
        'itemMenu1',
        'itemMenu2',
        'itemMenu3',
        'itemMenu4',
        'itemMenu5',
        'itemMenu6',
        'itemMenu7',
        'itemMenu8',
        'itemMenu9',
        'itemMenu10',
        'itemMenu11',
        'itemMenu12'
      ]
    }
  },
  methods: {
    menuMouseOver () {
      this.showMenu = true
    },
    menuMouseOut () {
      this.showMenu = false
    },
    goByIndex () {
      this.$router.push('/index')
    },
    goByPt() {
      this.$router.push({
        path: '/categoryProduct', query: {id: 1, name: '精品推荐'}
      })
    },
    goByqg() {
      this.$router.push({
        path: '/categoryProduct', query: {id: 2, name: '热门榜单'}
      })
    },
    goByjz() {
      this.$router.push({
        path: '/categoryProduct', query: {id: 3, name: '首发新品'}
      })
    },
    goByms() {
      this.$router.push({
        path: '/categoryProduct', query: {id: 4, name: '促销单品'}
      })
    },
    goSiteConfig (type) {
      this.$router.push({path: '/about', query: {type}})
    },
    goSiteConfig3 (type) {
      this.$router.push({path: '/contact', query: {type}})
    },
    goSiteConfig4 (type) {
      this.$router.push({path: '/realize', query: {type}})
    },
    // 隐藏分类
    hideType() {
      console.log(this.hideTypeStatus)
      if (this.hideTypeStatus) {
        this.hideTypeStatus = false
      } else {
        this.hideTypeStatus = true
      }
    },
    goProduct(id, name) {
      // :to="{path:'/categoryProduct',query:{id:2, name:'热门榜单'}}"
      this.$router.push({
        path: '/categoryProduct',
        query: {
          id: id,
          name: name
        }
      })
    },
    ...mapMutations({
      setComponentsData: 'SET_COMPONENTSDATA',
      setCurrentPro: 'SET_CURRENTPRO',
      show(cont) {
        this.isshow = cont
      }
    }),
    search() {
      console.log(this.search_text)
      // let paramsMenu = {
      //       url: api.getSearchProducts+"/"+this.search_text,
      //       method: "GET",
      //     };
      //     this.sendReq(paramsMenu, (res) => {
      //       console.log(res);
      //     });

      this.$router.push({
        path: '/search', query: {keyword: this.search_text}
      })
    },
    canvasGet () {
      // 左侧菜单获值
      let paramsMenu = {
        url: api.getCanvasMenu,
        method: 'GET'
      }
      this.sendReq(paramsMenu, (res) => {
        this.categoryMenu = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.el-icon-search{
  position: absolute;
  margin-top: 33px;
  margin-left: 16px;
}

.header_btn{
  background: #FF7800;
  border: none;
  height: 42px;
  line-height: 42px;
  padding: 0px 15px;
  //outline:none;
  color:white;
  margin-left: -5px;
  border-radius: 0 4px 4px 0;
}
.header_input{
  text-indent: 50px;
  outline:none;
  border: 1px solid #FF7800;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0px 15px;
  width: 370px;
  margin-top: 20px;
  border-radius: 4px 0 0 4px;
}
.header,.header_b{
  height: 82px;
  //background-color: #F1F2F7;
  line-height: 42px;
  font-size: 14px;
}
.header_b{
  display: flex;
  position: relative;
}

.conte{
  width: 1255px;
  margin: 0 auto;
}

.conte1 .header_xuan{
  //width: 1250px;
  margin: 0 auto;
  position: relative;
  left: 15.7%;
}

.menu-con {
  width: 200px;
  position: absolute;
  left: 0;
  top: 0;
}
.hoverDiv {
  &:hover{
    .caidan{
      display: block;
    }
  }
}
.menu-item {
  height: 28px;
  line-height: 28px;
  padding-left: 15px;
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 7px;
  margin-bottom: 7px;
  margin-left: 5px;
  font-family: 'Microsoft YaHei';
  overflow: hidden;
  &:hover{
    color: #baf613;
    .hoverBox{
      display: block;
    }
  }
}

.hoverBox{
  position: absolute;
  width: 1000px;
  padding:10px 25px;
  height: 1000px;
  left: 100%;
  top: 0;
  z-index: 3;
  display: none;
  background-color: #FFFFFF;
  color: #333;
  //border: 2px solid $mainColor;
  overflow-x: hidden;
  // overflow: scroll-y;
  .over{
    width: 1000px;
    padding:10px;
    height: 800px;
  }
  dl{
    margin-bottom: 5px;
    dt{
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
      border-bottom: 1px dashed rgba(200,200,200,0.5);
    }
    dd{
      line-height: 26px;
      font-size: 12px;
      margin-left: 0;
      a{
        margin-right: 12px;
        &:hover{
          color: $mainColor;
        }
      }
    }
  }
}

.likeProItem{
  padding: 15px 10px;
  background-color: white;
}
.main_shop1{
  margin-top: 0;
  background-color: #f3f5f6;
  padding: 15px 0px;
}
.main_shop1:hover {
  transform: scale(1.1);
  box-shadow: 2px 2px 1px #e4e4e4;
}
.caidan{
  width: 200px;
  height: 500px;
  position: absolute;
  z-index: 777;
  top: 36px;
  overflow: visible;
  display: none;
  //margin-left: 0;
  background-color: hsla(120, 100%, 14%, 0.2);
}
.main_shop1_ite:hover{
  //transform: scale(1.1);
}
.main_im{
  margin-top: 50px;
}
.shopitem{
  // margin-top: 35px;
}
// .main{
//   margin-top: 50px;
// }
.main_im{
  margin-top: 0;
}
.three{
  width: 500px;
  height: 40px;
  line-height: 40px;
  z-index: 4;
}
.three-in{
  height: 40px;
  line-height: 40px;
  display: inline-block;
  font-size: 18px;
  margin-right: 10px;
}
.four{
  font-size: 12px;
  width: 80px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  margin-right: 12px;
}
.four-in{
  width: 120px;
  height: 40px;
  display: inline-block;
}
.header_img[data-v-85b972c4] {
  height: 50px;
  margin-left: 0px;
}
.header_img img{
  width: 252px;
  height: 83px;
}
.w {
  width: 1255px;
  min-width: 1255px;
  margin: 0 auto;
}
.lists{
  border: 1px solid #006965;
  width: 100%;
  min-width:1420px;
  height: 35px;
  position: absolute;
  z-index: 5;
  top: 141px;
  background-color: #006865;
  display: flex;
}
.lists h3{
  float: left;
  width: 200px;
  height: 35px;
  display: block;
  line-height: 30px;
  text-align: left;
  font-weight: 500;
  font-size: 18px;
  color: white;
  background-color: #006865;
  //padding-left: 14.5%
  i {
    height: 17px;
    width: 19px;
    background-image: url(../../../static/image/menu-til.png);
    float: left;
    margin-top: 9px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
.lists ul{
  //width: 1000px;
  height: 35px;
  display: flex;
  float: left;
  list-style-type: none;
  color: white;
}
.lists li{
  //width: 100px;
  padding:0 17px;
  height: 35px;
  text-align: center;
  line-height: 30px;
  display: block;
  float: left;
  margin-right: 1px;
  font-size: 16px;
  font-weight: 500px;
}
.one{
  margin-left: 20px;
}

.el-carousel{
  position: relative;
}
.el-carousel__container{
  width: 100%;
  margin: auto;
  position: absolute;
}
.el-carousel__item .is-animating{
  margin: 0 auto;
}
.el-carousel__item img{
  //  width: 100%;
  width: 1800px;
  display: block;
  margin: auto;
}
.header_input_right{
  left:100px
}
/* 针对下方子轮播图 */
.main_im .el-carousel__item,.main_im .el-carousel__item img {
  line-height: 249.167px;
  margin: 0;
  height: 249.167px;
}
.main_im .el-carousel__item img{
  width: 100%;
}
.icon-item {
  display: inline-block;
  width: 16px;
  height: 100%;
  margin-right: 8px;
  padding-right: 10px;
  vertical-align: top;
  *vertical-align: middle;
  background-image: url(../../../static/image/menu_cate.png);
  background-repeat: no-repeat;
}
.itemMenu1 {
  background-position: 0px 0px;
}

.itemMenu2 {
  background-position: 0px -30px;
}
.itemMenu3 {
  background-position: 0px -60px;
}
.itemMenu4 {
  background-position: 0px -90px;
}
.itemMenu5 {
  background-position: 0px -120px;
}
.itemMenu6 {
  background-position: 0px -150px;
}
.itemMenu7 {
  background-position: 0px -180px;
}
.itemMenu8 {
  background-position: 0px -210px;

}
.itemMenu9 {
  background-position: 0px -240px;
}

.itemMenu10 {
  background-position: 0px -270px;
}

.itemMenu11 {
  background-position: 0px -300px;
}

.itemMenu12 {
  background-position: 0px -330px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/lateralNavigation2.vue